<template>
  <div>
    <BaseSheet>
      <v-form ref="brandComponentForm" v-model="valid" lazy-validation>
        <v-container class="mx-0 mt-0" fluid>
          <v-tabs>
            <v-tab>Common</v-tab>
            <v-tab>Specification</v-tab>
            <v-tab>Providers components</v-tab>
            <v-tab-item>
              <v-row dense class="mt-5 mx-1" justify="space-between">
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-text-field label="MPN"
                                :key="ignoreFlag"
                                v-model="mpn"
                                :rules="mpnRules"
                                required outlined dense></v-text-field>
                </v-col>
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-select label="Category"
                            :key="ignoreFlag"
                            :items="getCategories"
                            v-model="subcategory__category"
                            readonly
                            outlined dense></v-select>
                </v-col>
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-select label="Sub category"
                            :key="ignoreFlag"
                            :items="getSubCategories"
                            v-model="subcategory"
                            outlined dense></v-select>
                </v-col>
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-select label="Brand"
                            :key="ignoreFlag"
                            :loading="getBrandListLoading"
                            :items="getSelectBrandList"
                            v-model="brand"
                            outlined dense></v-select>
                </v-col>
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-text-field label="Datasheet"
                                :key="ignoreFlag"
                                v-model="datasheet"
                                validation="starts_with:http"
                                required outlined dense></v-text-field>
                </v-col>
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-text-field label="url"
                                :key="ignoreFlag"
                                v-model="url" :rules="linkRules"
                                required outlined dense></v-text-field>
                </v-col>
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-textarea label="Description"
                              :key="ignoreFlag"
                              v-model="description"
                              auto-grow clearable outlined dense></v-textarea>
                </v-col>
                <v-col cols="6" lg="6" md="12" sm="12" xl="12">
                  <v-textarea label="Information"
                              :key="ignoreFlag"
                              v-model="information"
                              auto-grow clearable outlined dense></v-textarea>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <BrandComponentSpec
                  v-bind:brandComponentId="$route.params.brandComponentId"
                  v-bind:brandComponentCategory="this.subcategory__category"
              ></BrandComponentSpec>
            </v-tab-item>
            <v-tab-item>
              <BrandComponentProviderComponent
                  v-bind:brandComponentId="$route.params.brandComponentId"
                  hide-default-footer
                  :height="$vuetify.breakpoint.height - 330"
              ></BrandComponentProviderComponent>
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-form>
      <template v-slot:footer>
        <BaseConformSave
            class="mr-4" :on-save-external="submit" color="primary"
            :disabled="!valid || saving"
            :loading="saving">
        </BaseConformSave>
        <v-btn class="mr-4" :to="{name: 'BrandComponentList'}">cancel</v-btn>
      </template>
    </BaseSheet>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {createHelpers} from 'vuex-map-fields'

import BrandComponentSpec from "@/components/Brand/BrandComponentSpec";
import BrandComponentProviderComponent from "@/components/Brand/BrandComponentProviderComponent";
import {required, digits, email, max, regex} from 'vee-validate/dist/rules'
import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'

const {mapFields} = createHelpers({
  getterType: 'getFieldBrandComponentItem',
  mutationType: 'updateFieldBrandComponentItem',
});

setInteractionMode('eager')

extend('digits', {
  ...digits,
  message: '{_field_} needs to be {length} digits. ({_value_})',
})

extend('required', {
  ...required,
  message: '{_field_} can not be empty',
})

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
})

extend('regex', {
  ...regex,
  message: '{_field_} {_value_} does not match {regex}',
})

extend('email', {
  ...email,
  message: 'Email must be valid',
})

export default {
  name: 'BrandComponentItem',
  props: {
    brandComponentId: {type: [Number, String], default: null},
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    BrandComponentSpec,
    BrandComponentProviderComponent,
  },

  computed: {
    ...mapGetters(['getBrandComponentItem', 'getSelectBrandList', 'getBrandListLoading',
      'getCategories', 'getSubCategories']),
    ...mapFields(['brandComponentItem.mpn',
      'brandComponentItem.subcategory__category', 'brandComponentItem.subcategory',
      'brandComponentItem.brand', 'brandComponentItem.article',
      'brandComponentItem.datasheet', 'brandComponentItem.url', 'brandComponentItem.description',
      'brandComponentItem.information',
    ]),
  },
  methods: {
    ...mapActions(['fetchBrandComponentItem', 'fetchBrandList',
      'saveBrandComponentItem', 'saveBrandComponentSpec',
      'fetchCategoryList', 'fetchSubCategoryList']),
    submit() {
      console.log('on-save-external')
      this.saving = true
      console.log(this.$root.$store.state.BrandComponentItem)
      this.saveBrandComponentItem(this.$route.params.brandComponentId)
      this.saveBrandComponentSpec(this.$route.params.brandComponentId)
      this.saving = false
    },
    ignore() {
      this.ignoreFlag = !this.ignoreFlag
      this.fetchBrandComponentItem(this.$route.params.brandComponentId)
    },
    validate() {
      this.$refs.form.validate()
    },
  },

  async mounted() {
    this.fetchBrandComponentItem(this.$route.params.brandComponentId)
    this.fetchBrandList();
    this.fetchCategoryList()
    this.fetchSubCategoryList()
  },

  data() {
    return {
      valid: true,
      saving: false,
      ignoreFlag: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      mpnRules: [
        v => !!v || 'MPN is required',
        v => (v && v.length <= 50) || 'MPN must be less than 50 characters',
      ],
      linkRules: [],
    }
  },

}
</script>

<style scoped lang="scss">
</style>
